import {
	FieldConfig,
	SearchFormTypes,
} from "../../../Shared/Components/SearchFormWrapper";
import { ReservationSearchFilters } from "../../Types/reservationTypes";

export const fieldsSearch: FieldConfig<ReservationSearchFilters>[] = [
  {
    name: 'offerId',
    label: 'Oferta',
    type: SearchFormTypes.select,
    options: [],
  },
  {
    name: 'createdAt',
    label: 'Data utworzenia',
    type: SearchFormTypes.date,
    value: '',
  },

  {
    name: 'applicantFirstName',
    label: 'Imię wnioskodawcy',
    type: SearchFormTypes.input,
    value: '',
  },
  {
    name: 'applicantLastName',
    label: 'Nazwisko wnioskodawcy',
    type: SearchFormTypes.input,
    value: '',
  },
  {
    name: 'applicantEmail',
    label: 'Email wnioskodawcy',
    type: SearchFormTypes.email,
    value: '',
  },
  {
    name: 'source',
    label: 'Źródło',
    type: SearchFormTypes.input,
    value: '',
  },
];
